module.exports = __webpack_public_path__ + "img/JobsHeader.34e35f47.jpg";